// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

// Use the SOLUTIONS array below to override or add information to your solutions. This can be useful for development
// purposes, but it is recommended to leave this array empty and use the API to update your Solution instead for
// production environments.
export const SOLUTIONS = [];
